module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Fragment', [_c('div', {
    staticClass: "container"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Review entry")]), _vm._v(" "), _c('Article', {
    attrs: {
      "article": _vm.article,
      "showAuthor": _vm.role !== 'reviewer',
      "term": _vm.term
    }
  })], 1), _vm._v(" "), (['reviewer', 'admin', 'god'].includes(_vm.role)) ? _c('div', {
    staticClass: "container-fluid yellow"
  }, [(['admin', 'god'].includes(_vm.role)) ? _c('div', {
    staticClass: "container"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Review Assignments")]), _vm._v(" "), _c('ReviewersForm', {
    attrs: {
      "reviewers": _vm.reviewers,
      "reviews": _vm.reviews
    }
  }), _vm._v(" "), ((_vm.reviews[0].text && _vm.reviews[0].text.length > 0) || (_vm.reviews[1].text && _vm.reviews[1].text.length > 0)) ? _c('span', {
    staticClass: "tit"
  }, [_vm._v("Reviewing")]) : _vm._e(), _vm._v(" "), (_vm.reviews[0].text && _vm.reviews[0].text.length > 0) ? _c('ReviewForm', {
    attrs: {
      "disabled": true,
      "review": _vm.reviews[0]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.reviews[1].text && _vm.reviews[1].text.length > 0) ? _c('ReviewForm', {
    attrs: {
      "disabled": true,
      "review": _vm.reviews[1]
    }
  }) : _vm._e(), _vm._v(" "), (['god', 'admin'].includes(_vm.role)) ? _c('div', {
    staticClass: "container"
  }, [_c('label', [_vm._v("STATUS")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "status-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateStatus()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Needs Corrections")]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": "",
      "value": "10"
    }
  }, [_vm._v("Submitted")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "40"
    }
  }, [_vm._v("Refused")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("Published")])])]) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "value": "Finish",
      "type": "submit",
      "name": ""
    },
    on: {
      "click": function($event) {
        return _vm.submitReviews()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.role === 'reviewer') ? _c('div', {
    staticClass: "container"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Reviewing")]), _vm._v(" "), _c('ReviewForm', {
    attrs: {
      "review": _vm.reviews[0]
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "value": "Finish",
      "type": "submit",
      "name": ""
    },
    on: {
      "click": function($event) {
        return _vm.submitReview(_vm.reviews[0])
      }
    }
  })], 1) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57910622!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReviewPage.vue
// module id = 164
// module chunks = 2